import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField/TextField';
import globalContext from '../../../../config/context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogKoordinat = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {latitude, setLatitude, longitude, setLongitude, onCariKoordinat} = props;

  return (
    <div className={classes.root}>
      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Latitude"
        variant="outlined"
        value={latitude}
        onChange={(e) => setLatitude(e.target.value)}
      />

      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Longitude"
        variant="outlined"
        value={longitude}
        onChange={(e) => setLongitude(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onCariKoordinat();
          }
        }}
      />
    </div>
  );
};

export default DialogKoordinat;
